import { ReactNode } from 'react';
import { IconButton, Stack, StackProps } from '@prenuvo/halo-foundation';
import { Cross } from '@prenuvo/halo-icon';

interface SidePanelHeaderProps {
  onCloseClick: () => void;
  title?: ReactNode;
  titleJustification: StackProps['justification'];
}

export function SidePanelHeader({ onCloseClick, title, titleJustification }: SidePanelHeaderProps) {
  return (
    <Stack alignment="center" className="z-40 w-full p-2" justification={titleJustification}>
      {title}

      <IconButton aria-label="Close" icon={Cross} onClick={onCloseClick} size="sm" variant="text" />
    </Stack>
  );
}
